"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PartnerSupportTicketOrigin = void 0;
/** Where a partner support ticket was opened from. */
var PartnerSupportTicketOrigin;
(function (PartnerSupportTicketOrigin) {
    PartnerSupportTicketOrigin["DASHBOARD"] = "dashboard";
    PartnerSupportTicketOrigin["SUPPORT_CALL"] = "support_call";
})(PartnerSupportTicketOrigin || (exports.PartnerSupportTicketOrigin = PartnerSupportTicketOrigin = {}));
